import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useContext, useEffect, useState } from 'react';
import { getCustomDropownData } from '../../API/api';
import { titleFromParams } from '../../Utilities/helperFunction';
import appContext from '../../appContext';
import SearchDropdown from '../SearchDropdown';
import './style.scss';

const DropDown = ({ setMarketingAgency, addNextData, mock, index, rightIcon, realData, initialValues, setApiBtnDropLoading, setValue, maintainValues, setMaintainValues, setScrollDisable, isCountry, countryArray }) => {
    const { setCustomStyles, dropdownData, dependedHistory, setDependedHistory, setDropdownData, csvDropdownData, isCdrReport } = useContext(appContext)
    const [options, setOptions] = useState([])

    let name = ''
    if (initialValues && initialValues[index - 1]) {
        name = initialValues[index - 1]
    }

    const getQuestionName = (dropDependedName, nextDropdown) => {
        if (realData.length) {
            const filteredData = realData.filter((real) => real.dropDependedName == dropDependedName)
            if (filteredData.length) {
                filteredData.forEach((data) => {
                    setDropdownData(dropdownData => ({ ...dropdownData, [data.name]: nextDropdown.data?.dropdownData }))
                })
            }
        }
    }

    const handleChange = async (event) => {
        try {
            const value = event?.target?.value;
            setValue(initialValues[index - 1], value);
            setMaintainValues({ ...maintainValues, [`${name}`]: value })
            const dependedHistoryClone = { ...dependedHistory }

            let selectedOptions = [];
            if (Array.isArray(value)) {
                selectedOptions = mock?.options?.filter((selectedOption) => value.includes(selectedOption?.value))
            } else {
                selectedOptions = mock?.options?.filter((selectedOption) => selectedOption?.value === value)
            }
            dependedHistoryClone[name] = selectedOptions.map((option) => option?.id)
            setDependedHistory({ ...dependedHistoryClone })
            setScrollDisable(false)
            const apiValues = { ...mock.callApiOnSelect }
            if (apiValues?.isActivated && !Array.isArray(value)) {
                setApiBtnDropLoading(true)
                apiValues['dropdown_endPoint'] += `${apiValues?.dropdown_endPoint.includes("?") ?
                    "&" : "?"
                    }${apiValues?.searchKey}=${value} `
                const nextDropdown = await getCustomDropownData(apiValues)
                if (nextDropdown.data?.dropdownData?.length > 0) {
                    const dependedName = getQuestionName(apiValues?.dropDependedName, nextDropdown)
                    setDropdownData(dropdownData => ({ ...dropdownData, [dependedName]: nextDropdown.data?.dropdownData }))
                }
            }
            addNextData(value, index, mock?._id, Array.isArray(value) ? 'checkbox' : 'dropdown', dependedHistoryClone)
            setApiBtnDropLoading(false)
            if (name === "industry") {
                if (value === "Marketing Agency") {
                    setMarketingAgency(true)
                } else {
                    setMarketingAgency(false)
                }
            }
        } catch (error) {
            setApiBtnDropLoading(false)
            console.error('error in handleChange dropdown', error)
        }
    };

    const handleSearchChange = async (value) => {
        try {
            setValue(initialValues[index - 1], value);
            setMaintainValues({ ...maintainValues, [`${name}`]: value })
            const apiValues = { ...mock.callApiOnSelect }
            if (apiValues?.isActivated) {
                setApiBtnDropLoading(true)
                apiValues['dropdown_endPoint'] += `${apiValues?.dropdown_endPoint.includes("?") ?
                    "&" : "?"
                    }${apiValues?.searchKey}=${value} `
                const nextDropdown = await getCustomDropownData(apiValues)
                if (nextDropdown.data?.dropdownData?.length > 0) {
                    getQuestionName(apiValues?.dropDependedName, nextDropdown)
                }
            }
            const dependedHistoryClone = { ...dependedHistory }
            let selectedOptions = [];
            if (Array.isArray(value)) {
                selectedOptions = mock?.options?.filter((selectedOption) => value.includes(selectedOption?.value))
            } else {
                selectedOptions = mock?.options?.filter((selectedOption) => selectedOption?.value === value)
            }
            dependedHistoryClone[name] = selectedOptions.map((option) => option?.id)
            setDependedHistory({ ...dependedHistoryClone })
            setScrollDisable(false)
            addNextData(value, index, mock?._id, Array.isArray(value) ? 'checkbox' : 'dropdown', dependedHistoryClone)
            setApiBtnDropLoading(false)
        } catch (err) {
            setApiBtnDropLoading(false)
            console.error("error in handleSearchChange", err);
        }
    }

    useEffect(() => {
        if (isCountry && countryArray?.length) {
            mock['options'] = countryArray
        }
    }, [isCountry])

    useEffect(() => {
        if (isCdrReport && csvDropdownData?.headers?.length && !mock?.options?.length) {
            const csvData = csvDropdownData?.headers?.filter((data) => data)?.map((csvHeaders) => ({
                label: csvHeaders,
                value: csvHeaders
            }))
            csvData.push({
                label: "Not available",
                value: "Not available"
            })
            setOptions(csvData || [])

        } else {
            if (Object.keys(dropdownData)?.includes(name) && dropdownData[name]?.length) {
                setOptions(dropdownData[name])
            } else {
                setOptions(mock?.options || [])
            }
        }
        setCustomStyles(mock?.styles || {})
    }, [dropdownData])

    return (
        <div className="dropdown-container">
            <div className='dropdown-title' >
                <h1 className='title'><span>{index}
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 24 24" >
                        <path
                            d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
                    </svg>
                </span><div dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }} /></h1>
                <div className='description-container' dangerouslySetInnerHTML={{ __html: mock?.description }} />
            </div>

            {mock?.isSearchEnabled ? <SearchDropdown options={options} onMouseEnter={() => setScrollDisable(true)} onMouseLeave={() => setScrollDisable(false)} onChange={handleSearchChange} mock={mock} defaultValue={maintainValues[name] ?? ""} name={name} />
                : <FormControl hiddenLabel onMouseEnter={() => setScrollDisable(true)} onMouseLeave={() => setScrollDisable(false)} sx={{ m: 1 }}>
                    <InputLabel hiddenLabel disableAnimation htmlFor="name-multiple" >Click to select</InputLabel>
                    <Select
                        multiple={mock?.isMultiple}
                        value={maintainValues[name] ?? (mock?.isMultiple ? [] : "")}
                        disableUnderline={true}
                        onChange={handleChange}
                        sx={{
                            '& fieldset': { top: 0 }
                        }}
                        variant="standard"
                        InputLabelProps={{ shrink: false }}
                        renderValue={(selected) => {
                            if (mock?.isMultiple) {
                                if (!selected || !selected.length) return <em>Click to select</em>;
                                const selectedLabels = options
                                    .filter(opt => selected.includes(opt.value))
                                    .map(opt => opt.label);
                                return selectedLabels.join(', ');
                            }
                            if (!selected) return <em>Click to select</em>;
                            const selectedOption = options.find(opt => opt.value === selected);
                            return selectedOption ? selectedOption.label : selected;
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    color: "#FFFF",
                                    background: "transparent",
                                    marginBottom: '10px',
                                    borderBottom: '2px dashed #FFFF',
                                },
                            },
                        }}
                    >
                        {options?.map((ele, index) => {
                            return (
                                <MenuItem key={index} value={ele?.value} className="Dropdown-menuItem">
                                    {mock?.isMultiple && (
                                        <Checkbox
                                            checked={(maintainValues[name] || []).indexOf(ele?.value) > -1}
                                            sx={{
                                                color: "white",
                                                '&.Mui-checked': {
                                                    color: "white",
                                                },
                                            }}
                                        />
                                    )}
                                    <ListItemText primary={ele?.label} />
                                </MenuItem>
                            )
                        })
                        }
                    </Select>
                </FormControl>}
        </div>
    );
};

export default DropDown;